module.exports = __webpack_public_path__ + "img/calendar.7b5562f8.svg";